import type { EntitySuggestion } from '@bliks-io/contracts';

/**
 * Outcome of the suggest-new dialog, discriminated so every consumer can tell
 * a brand-new create apart from the adoption of a pre-existing pending
 * suggestion (picked from the duplicate panel). The distinction matters for
 * withdraw-on-cancel flows: only `created` suggestions belong to the session
 * that made them — an adopted one predates the dialog and must never be
 * withdrawn by it. `created` carries the full doc so those flows can seed
 * their proposed-name lookups without a refetch.
 */
export type SuggestionPickEvent =
  | { kind: 'created'; suggestion: EntitySuggestion }
  | { kind: 'adopted'; suggestionId: string };

/** The picked suggestion's id, regardless of how it entered the slot. */
export function suggestionPickId(event: SuggestionPickEvent): string {
  return event.kind === 'created' ? event.suggestion._id : event.suggestionId;
}
